import React, { useEffect, useState } from 'react'
import { Button, Icon, Modal, Tooltip } from 'antd'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { FormWrapperItem } from '../../../../common/component/Index'
import { fillSupplierNameForProduct } from 'utils/commonUtils'
import AntSelect, { AntOption } from '../../../../common/component/AntSelect';
import Wrapper from '../../../../common/component/Wrapper'
import DualListBox from 'react-dual-listbox'
import * as Func from '../../../../../../helpers/functions'
import * as HMS from "../../../../common/component/Index";
import 'react-dual-listbox/lib/react-dual-listbox.css';
import './ListSupplier.less';

const ListSupplier = ({ ...props }) => {
    const { t } = useTranslation();
    const { allSuppliers, className, buttonText, onChange, getSupplierAll, getListProductBySupplier, supplierState, productsData } = props;
    const { isFetchingProduct, supplierProducts } = supplierState;
    const [visible, setVisible] = useState(false);
    const [supplierIds, setSupplierIds] = useState([]);
    const [productSelected, setProductSelected] = useState([]);
    const [allProduct, setAllProduct] = useState([]);
    const [isOnBlurSupplier, setIsOnBlurSupplier] = useState(true);
    const [isCheckSupplierIds, setIsCheckSupplierIds] = useState(false);

    useEffect(() => {
        getSupplierAll && getSupplierAll({ pageIndex: 1, pageSize: 100, ProductType: 7 });
    }, []);

    useEffect(() => {
        if (supplierIds.length > 0 && supplierIds.length === allSuppliers.length){
            setIsCheckSupplierIds(true)
            return;
        } return setIsCheckSupplierIds(false);
    }, [supplierIds, allSuppliers])

    useEffect(() => {
        if (supplierIds && supplierIds.length > 0) { 
            setProductSelected([...productSelected])
            setAllProduct([...fillSupplierNameForProduct(supplierProducts)]);
        } else {
            setProductSelected([]);
            setAllProduct([])
        }
    }, [supplierProducts])

    useEffect(() => {
        if (!isOnBlurSupplier && visible) {
            const request = {
                supplierIds: supplierIds,
                active: true,
                pageIndex: 1,
                pageSize: 1000,
            }
            getListProductBySupplier && getListProductBySupplier(request);
        }
    }, [supplierIds]);
    
    useEffect(() => {
        if (productsData && productsData.details.length > 0 && visible) {
            const suppliers = [];
            const arrProductIds = [];
            productsData.details.map(item => {
                if (suppliers && !suppliers.includes(item.supplierId))
                    suppliers.push(item.supplierId);
                const productIds = item.productIds;
                if (productIds && productIds.length > 0) {
                    productIds.map(itemProduct => {
                        arrProductIds.push(`${ item.supplierId }:${ itemProduct }`);
                    })
                }
            });
            setProductSelected([...arrProductIds]);
            setSupplierIds([...suppliers]);

            const request = {
                supplierIds: suppliers,
                active: true,
                pageIndex: 1,
                pageSize: 1000,
            }
            getListProductBySupplier && getListProductBySupplier(request);
            selectedItemFunc();
        }
    }, [productsData, visible]);

    const onChangeSupplier = (ids) => {
        const cloneSupplier = allSuppliers && allSuppliers.map((el) => el.id
        );
        const isSelectAll = ids.includes('all');
        if(isSelectAll){
            setSupplierIds(cloneSupplier);
            return;
        }
        setSupplierIds(ids);
    };

    const onBlurSupplier = () => {
        setIsOnBlurSupplier(false);
        if ( supplierIds && supplierIds.length > 0) {
            setProductSelected([...productSelected])
            setAllProduct([...fillSupplierNameForProduct(supplierProducts)]);
            if (visible) { 
                const request = {
                    supplierIds: supplierIds,
                    active: true,
                    pageIndex: 1,
                    pageSize: 1000,
                }
                getListProductBySupplier && getListProductBySupplier(request);
            }
        } else {
            setProductSelected([]);
            setAllProduct([]);
        }
        
    }

    const clearData = () => {
        setSupplierIds([]);
        setProductSelected([]);
        setAllProduct([]);
    }

    const selectedItemFunc = () => {
        return productSelected;
    }

    const showModal = () => {
        setVisible(true);
    };

    const handleOk = () => {
        onChange && onChange(supplierIds, productSelected);
        setVisible(false);
        clearData();
    };

    const handleCancel = () => {
        setVisible(false);
        clearData();
    };

    const onChangeProducts = (selected) => {
        setProductSelected(selected);
    };
    
    const onFilter = (option, filterInput) => {
        if (filterInput === '') {
            return true;
        }
        const optionText = Func.vietnameseStringToUnicode(option.label.toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(filterInput.toLowerCase());
        return optionText.indexOf(inputText) >= 0 || optionText.indexOf(inputText) >= 0;
    }

    const selectFilterSearch = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode(option.props?.children?.props?.children?.toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    };
    
    return (
        <Fragment>
            <Button className={className} type="primary" onClick={showModal}>
                {buttonText || t(`item.campaign.selectSkuIds`)}
            </Button>
            <Modal title={t(`item.campaign.selectSkuIds`)}
                width={1200}
                visible={visible}
                onOk={handleOk}
                onCancel={handleCancel}
                maskClosable={false}
                okButtonProps={{
                    disabled: productSelected.length == 0
                }}
            >
                <FormWrapperItem classParent='wt-box-content'>
                    <Wrapper className='col-md-12'>
                        <AntSelect className="select-types"
                            showArrow
                            allowClear
                            placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.promotions.supplier")).toLowerCase())}
                            value={supplierIds}
                            onFocus={() => { setIsOnBlurSupplier(true) }}
                            onChange={ids =>
                            {
                                onChangeSupplier(ids)
                            }}
                            onBlur={() => onBlurSupplier()}
                            style={{ width: '100%' }}
                            mode="multiple"
                            filterOption={selectFilterSearch}

                        >
                            <AntOption value='all' disabled={isCheckSupplierIds}>
                                <Tooltip title={t(`item.campaign.supplierAllHotel`)} placement="topLeft">
                                    {t(`item.campaign.supplierAllHotel`)}
                                </Tooltip>
                            </AntOption>
                            {(allSuppliers || []).map(supplier => (
                                <AntOption key={supplier.id} value={supplier.id}>
                                    <Tooltip title={supplier.supplierName} placement="topLeft">{`${supplier.code} - ${supplier.supplierName}`}</Tooltip>
                                </AntOption>
                            ))}
                        </AntSelect>
                    </Wrapper>
                </FormWrapperItem>
                <HMS.LoadingComponent spinning={isFetchingProduct}>
                <Wrapper className='col-md-12 dual-list-apply-hotel'>
                    <DualListBox
                        canFilter
                        filterPlaceholder={t('action.search')}
                        filterCallback={onFilter}
                        options={
                            (allProduct || []).map(item => (
                                {
                                    label: item.name,
                                    options: item.productsList.map(itemProduct => ({
                                        ...itemProduct,
                                        label: `${itemProduct.productCode} - ${itemProduct.name}`,
                                        value: `${item.id}:${itemProduct.id}`,
                                    })),
                                }
                            ))
                        }
                        selected={[...productSelected]}
                        onChange={onChangeProducts}
                        icons={{
                            moveLeft: <Icon type="left" className="mx-2" />,
                            moveAllLeft: <Icon type="double-left" className="mx-2" />,
                            moveRight: <Icon type="right" className="mx-2" />,
                            moveAllRight: <Icon type="double-right" className="mx-2" />,
                        }}
                        disabled={!allProduct || (allProduct && allProduct.length <= 0)}
                    />
                </Wrapper>
                </HMS.LoadingComponent>
            </Modal>
        </Fragment>
    )
}

export default ListSupplier;
